import React, { Component } from "react";
import {
  Row,
  Col,
  Table,
  Button,
  Radio,
  Tooltip,
  Input,
  Spin,
  PageHeader,
  Affix,
} from "antd";
import Text from "antd/lib/typography/Text";
import Dialog from "../shared/dialog";
import ReactToPrint from "react-to-print";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "../shared/css/table.css";

const { TextArea } = Input;

export default class SubordinateReport extends Component {
  constructor(props) {
    super(props);
    console.log("props", props);

    this.state = {
      // language: this.props.lang,
      language: localStorage.getItem("Language"),
      tableData: [],
      Tooltip: [],
      //RUN: เพิ่ม Weight 14/04/2021
      weight: [],
      TooltipForEmp: [],
      record: [],
    };
    this.AnsData = {
      ansForm: [],
      ansFormArray: [],
      ansTotalClick: [],
      ansTotalClickTopic: [],
      ansTotalClickSubSubTopic: [],
      TotalCalculate: 0,
      ////////////////////////
      ansFormAssessor: [],
      ansFormAssessorArray: [],
      ansTotalAssessorClick: [],
      ansTotalAssessorClickTopic: [],
      ansTotalAssessorClickSubSubTopic: [],
      TotalAssessorCalculate: 0,
    };
    this.FromLocal = {
      PositionID: parseInt(this.props.location.state.record.PositionId),
      //RUN: เพิ่มตัวแปร PositionGroupID เพื่อเก็บค่าไว้ตรวจสอบการคำนวณ Weight คะแนน 14/04/2021
      PositionGroupID: this.props.location.state.record.GroupPostionId,
      field: parseInt(this.props.location.state.record.Field),
    };
    this.initArrays = {
      TopicsArr: [],
      SubTopicArr: [],
      SubSubTopicArr: [],
      //RUN: เพิ่ม ตัวแปร array เก็บค่า 14/04/2021
      UnderEmpAnsFormArr: [],
      PrimaryAnsFormArr: [],
    };
    this.dialog = new Dialog();

    console.log("props", props);
    console.log("this.props.lang", this.props.lang);
  }

  componentWillReceiveProps(nextProps) {
    console.log("nextProps", nextProps);
    this.setState({ language: nextProps.lang });
    localStorage.setItem("Language", nextProps.lang);
  }

  componentDidMount() {
    this.spinnerControl();

    fetch(process.env.REACT_APP_API_URL + "/api/getCriteriaAndUserAnsPrimary", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
        formtypeid: 2,
        empunderid: this.props.location.state.record.EmpId,
        empunderfield: this.props.location.state.record.Field,
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("resultsssss", result);
        result.forEach((e) => {
          this.initArrays.TopicsArr = e.Topics;
          this.initArrays.SubTopicArr = e.SubTopics;
          this.initArrays.PrimaryAnsFormArr = e.PrimaryAnsForm;
          this.initArrays.UnderEmpAnsFormArr = e.UnderEmpAnsForm;
          this.initArrays.SubSubTopicArr = e.SubSubTopics;
        });
        //   console.log('this.initArrays.TopicsArr',this.initArrays.TopicsArr)
        //   console.log('this.initArrays.SubTopicArr',this.initArrays.SubTopicArr)
        //   console.log('this.initArrays.PrimaryAnsFormArr',this.initArrays.PrimaryAnsFormArr)
        //   console.log('this.initArrays.UnderEmpAnsFormArr',this.initArrays.UnderEmpAnsFormArr)
        //   console.log('this.initArrays.SubSubTopicArr',this.initArrays.SubSubTopicArr)
        if (this.initArrays.UnderEmpAnsFormArr.length > 0) {
          this.initArrays.UnderEmpAnsFormArr.forEach((e) => {
            this.AnsData.ansForm.push({
              TopicId: e.TopicId,
              SubTopicId: e.SubTopicId,
              SubSubTopicId: e.SubSubTopicId,
              Point: e.Point,
              Remark: e.Remark,
              CalPoint: e.CalPoint,
              isCompetency: e.isCompetency,
            });
          });
        }
        if (this.initArrays.PrimaryAnsFormArr.length > 0) {
          this.initArrays.PrimaryAnsFormArr.forEach((e) => {
            this.AnsData.ansFormAssessor.push({
              TopicId: e.TopicId,
              SubTopicId: e.SubTopicId,
              SubSubTopicId: e.SubSubTopicId,
              Point: e.Point,
              Remark: e.Remark,
              CalPoint: e.CalPoint,
              isCompetency: e.isCompetency,
            });
          });
        }
        //RUN: เพิ่ม Weight ให้ Topic
        var tempWeightTopic;
        this.initArrays.TopicsArr.forEach((e) => {
          if (this.FromLocal.PositionGroupID == "E") {
            console.log("positionID = E");
            tempWeightTopic = e.WeightOfficer;
          } else if (this.FromLocal.PositionGroupID == "C") {
            tempWeightTopic = e.WeightLecturerOfficer;
          } else if (this.FromLocal.PositionGroupID == "B") {
            tempWeightTopic = e.WeightLecturer;
          } else if (
            this.FromLocal.PositionGroupID == "A" ||
            this.FromLocal.PositionGroupID == "D"
          ) {
            tempWeightTopic = e.WeightBoards;
          } else if (this.FromLocal.PositionGroupID == "F") {
            console.log("group = f");
            if (this.FromLocal.field == 1) {
              console.log("field 1");

              tempWeightTopic = e.WeightOfficer;
            } else {
              console.log("field 2");

              tempWeightTopic = e.WeightLecturer;
            }
          }
          this.state.weight.push({
            ToppicId: e.ToppicId.toString(),
            SubToppicId: 0,
            SubSubToppicId: 0,
            WeightBoards: e.WeightBoards,
            WeightLecturer: e.WeightLecturer,
            WeightLecturerOfficer: e.WeightLecturerOfficer,
            WeightOfficer: e.WeightOfficer,
            WeightCriteria: tempWeightTopic,
            IsMainTopic: true,
          });
        });
        //#region RUN: Key ไว้ดูว่า ตำแหน่งไหนใช้ Weight ตัวไหน 14/04/2021
        //KEY / Legend
        // WeightApply | GroupPositionID
        // WeightBoards : A,D
        // WeightLecturer : B
        // WeightLecturerOfficer : C
        // WeightOfficer : E
        //#endregion

        //RUN: เพิ่ม การตรวจสอบ employee คนนี้มีตำแหน่งอะไรและเลือกใช้ Weightให้ ถูกต้อง
        var tempWeightApplySubTopic;

        console.log("GroupPositionID", this.FromLocal.PositionGroupID);
        var nameWeightApply = "";
        if (this.FromLocal.PositionGroupID == "E") {
          nameWeightApply = "WeightOfficer";
        } else if (this.FromLocal.PositionGroupID == "C") {
          nameWeightApply = "WeightLecturerOfficer";
        } else if (this.FromLocal.PositionGroupID == "B") {
          nameWeightApply = "WeightLecturer";
        } else if (
          this.FromLocal.PositionGroupID == "A" ||
          this.FromLocal.PositionGroupID == "D"
        ) {
          nameWeightApply = "WeightBoards";
        } else if (this.FromLocal.PositionGroupID == "F") {
          if (this.FromLocal.field == 1) {
            nameWeightApply = "WeightOfficer";
          } else {
            nameWeightApply = "WeightLecturer";
          }
        }
        //RUN: ตัดข้อมูลที่ weight คะแนนเป็น 0 ออก
        this.initArrays.SubTopicArr = this.initArrays.SubTopicArr.filter(
          (e) => {
            return e[("", nameWeightApply)] !== 0;
          }
        );
        //RUN: ตัดข้อมูลที่ weight คะแนนเป็น 0 ออก
        this.initArrays.SubSubTopicArr = this.initArrays.SubSubTopicArr.filter(
          (e) => {
            return e[("", nameWeightApply)] !== 0;
          }
        );

        this.initArrays.SubTopicArr.forEach((e) => {
          //RUN: เพิ่มcondition ตรวจสอบว่าเป็นตำแหน่งใดและนำไปใช้ในตัวแปรtemp เพื่อส่งเข้า array
          if (this.FromLocal.PositionGroupID == "E") {
            tempWeightApplySubTopic = e.WeightOfficer;
          } else if (this.FromLocal.PositionGroupID == "C") {
            tempWeightApplySubTopic = e.WeightLecturerOfficer;
          } else if (this.FromLocal.PositionGroupID == "B") {
            tempWeightApplySubTopic = e.WeightLecturer;
          } else if (
            this.FromLocal.PositionGroupID == "A" ||
            this.FromLocal.PositionGroupID == "D"
          ) {
            tempWeightApplySubTopic = e.WeightBoards;
          } else if (this.FromLocal.PositionGroupID == "F") {
            if (this.FromLocal.field == 1) {
              tempWeightApplySubTopic = e.WeightOfficer;
            } else {
              tempWeightApplySubTopic = e.WeightLecturer;
            }
          }
          this.state.Tooltip.push({
            ToppicId: e.ToppicId,
            SubToppicId: e.SubToppicId,
            SubSubToppicId: 0,
            Tooltip1TH: e.Tooltip1TH,
            Tooltip1EN: e.Tooltip1EN,
            Tooltip2TH: e.Tooltip2TH,
            Tooltip2EN: e.Tooltip2EN,
            Tooltip3TH: e.Tooltip3TH,
            Tooltip3EN: e.Tooltip3EN,
            Tooltip4TH: e.Tooltip4TH,
            Tooltip4EN: e.Tooltip4EN,
            Tooltip5TH: e.Tooltip5TH,
            Tooltip5EN: e.Tooltip5EN,
            WeightBoards: e.WeightBoards,
            WeightLecturer: e.WeightLecturer,
            WeightLecturerOfficer: e.WeightLecturerOfficer,
            WeightOfficer: e.WeightOfficer,
            //RUN: WeightCriteria เพื่อนำไปใช้ในการวางคะแนนแบบ Global
            WeightCriteria: tempWeightApplySubTopic,
            showRemark: false,
            //RUN: เพิ่ม field isCompetency เพื่อใช้ตรวจสอบการ ว่าเป็นการประเมินด้าน สมรรณถนะ 18/04/2021
            isCompetency: e.isCompetency,
            Remarks: "",
          });
          this.state.TooltipForEmp.push({
            ToppicId: e.ToppicId,
            SubToppicId: e.SubToppicId,
            SubSubToppicId: 0,
            Tooltip1TH: e.Tooltip1TH,
            Tooltip1EN: e.Tooltip1EN,
            Tooltip2TH: e.Tooltip2TH,
            Tooltip2EN: e.Tooltip2EN,
            Tooltip3TH: e.Tooltip3TH,
            Tooltip3EN: e.Tooltip3EN,
            Tooltip4TH: e.Tooltip4TH,
            Tooltip4EN: e.Tooltip4EN,
            Tooltip5TH: e.Tooltip5TH,
            Tooltip5EN: e.Tooltip5EN,
            WeightBoards: e.WeightBoards,
            WeightLecturer: e.WeightLecturer,
            WeightLecturerOfficer: e.WeightLecturerOfficer,
            WeightOfficer: e.WeightOfficer,
            //RUN: WeightCriteria เพื่อนำไปใช้ในการวางคะแนนแบบ Global
            WeightCriteria: tempWeightApplySubTopic,
            showRemark: false,
            //RUN: เพิ่ม field isCompetency เพื่อใช้ตรวจสอบการ ว่าเป็นการประเมินด้าน สมรรณถนะ 18/04/2021
            isCompetency: e.isCompetency,
            Remarks: "",
          });
        });
        var tempWeightApplySubSubTopic;
        this.initArrays.SubSubTopicArr.forEach((e) => {
          //RUN: เพิ่มcondition ตรวจสอบว่าเป็นตำแหน่งใดและนำไปใช้ในตัวแปรtemp เพื่อส่งเข้า array
          if (this.FromLocal.PositionGroupID == "E") {
            tempWeightApplySubSubTopic = e.WeightOfficer;
          } else if (this.FromLocal.PositionGroupID == "C") {
            tempWeightApplySubSubTopic = e.WeightLecturerOfficer;
          } else if (this.FromLocal.PositionGroupID == "B") {
            tempWeightApplySubSubTopic = e.WeightLecturer;
          } else if (
            this.FromLocal.PositionGroupID == "A" ||
            this.FromLocal.PositionGroupID == "D"
          ) {
            tempWeightApplySubSubTopic = e.WeightBoards;
          } else if (this.FromLocal.PositionGroupID == "F") {
            if (this.FromLocal.field == 1) {
              tempWeightApplySubSubTopic = e.WeightOfficer;
            } else {
              tempWeightApplySubSubTopic = e.WeightLecturer;
            }
          }
          this.state.Tooltip.push({
            ToppicId: e.ToppicId,
            SubToppicId: e.SubToppicId,
            SubSubToppicId: e.SubSubToppicId,
            Tooltip1TH: e.Tooltip1TH,
            Tooltip1EN: e.Tooltip1EN,
            Tooltip2TH: e.Tooltip2TH,
            Tooltip2EN: e.Tooltip2EN,
            Tooltip3TH: e.Tooltip3TH,
            Tooltip3EN: e.Tooltip3EN,
            Tooltip4TH: e.Tooltip4TH,
            Tooltip4EN: e.Tooltip4EN,
            Tooltip5TH: e.Tooltip5TH,
            Tooltip5EN: e.Tooltip5EN,
            WeightBoards: e.WeightBoards,
            WeightLecturer: e.WeightLecturer,
            WeightLecturerOfficer: e.WeightLecturerOfficer,
            WeightOfficer: e.WeightOfficer,
            //RUN: WeightCriteria เพื่อนำไปใช้ในการวางคะแนนแบบ Global
            WeightCriteria: tempWeightApplySubSubTopic,
            showRemark: false,
            //RUN: เพิ่ม field isCompetency เพื่อใช้ตรวจสอบการ ว่าเป็นการประเมินด้าน สมรรณถนะ 18/04/2021
            isCompetency: e.isCompetency,
            Remarks: "",
          });
          this.state.TooltipForEmp.push({
            ToppicId: e.ToppicId,
            SubToppicId: e.SubToppicId,
            SubSubToppicId: e.SubSubToppicId,
            Tooltip1TH: e.Tooltip1TH,
            Tooltip1EN: e.Tooltip1EN,
            Tooltip2TH: e.Tooltip2TH,
            Tooltip2EN: e.Tooltip2EN,
            Tooltip3TH: e.Tooltip3TH,
            Tooltip3EN: e.Tooltip3EN,
            Tooltip4TH: e.Tooltip4TH,
            Tooltip4EN: e.Tooltip4EN,
            Tooltip5TH: e.Tooltip5TH,
            Tooltip5EN: e.Tooltip5EN,
            WeightBoards: e.WeightBoards,
            WeightLecturer: e.WeightLecturer,
            WeightLecturerOfficer: e.WeightLecturerOfficer,
            WeightOfficer: e.WeightOfficer,
            //RUN: WeightCriteria เพื่อนำไปใช้ในการวางคะแนนแบบ Global
            WeightCriteria: tempWeightApplySubSubTopic,
            showRemark: false,
            //RUN: เพิ่ม field isCompetency เพื่อใช้ตรวจสอบการ ว่าเป็นการประเมินด้าน สมรรณถนะ 18/04/2021
            isCompetency: e.isCompetency,
            Remarks: "",
          });
        });
        this.AnsData.ansForm.forEach((e1) => {
          this.state.TooltipForEmp.forEach((e2) => {
            if (
              e1.TopicId == e2.ToppicId &&
              e1.SubTopicId == e2.SubToppicId &&
              e1.SubSubTopicId == e2.SubSubToppicId
            ) {
              // console.log('eeeeeeeeeeeee',e2)
              // console.log('ewwwwwwwwwwwwwww',e1)

              e2.Remarks = e1.Remark;
              if (this.FromLocal.PositionID !== 19) {
                if (e2.isCompetency == 0 && e1.Point !== 3) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  this.FromLocal.PositionID > 6 &&
                  this.FromLocal.PositionID !== 4 &&
                  e1.Point !== 3
                ) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  this.FromLocal.PositionID <= 6 &&
                  this.FromLocal.PositionID !== 4 &&
                  e1.Point !== 4
                ) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  this.FromLocal.PositionID == 4 &&
                  e1.Point !== 3
                ) {
                  e2.showRemark = true;
                }
                //RUN เพิ่ม condition การ default value
              } else {
                if (e2.isCompetency == 0 && e1.Point !== 3) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  e1.Point !== 4 &&
                  e1.SubSubTopicId.toString() == "2"
                ) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  e1.Point !== 3 &&
                  e1.SubSubTopicId.toString() !== "2"
                ) {
                  e2.showRemark = true;
                }
              }
            }
          });
        });

        //RUN ตัวนี้จำเป็นสำหรับการ Check ค่า Remark ถ้ามีให้แสดงด้วยแต่ถ้าเป็น default ต้องให้ไม่แสดง 16/04/2021
        this.AnsData.ansFormAssessor.forEach((e1) => {
          this.state.Tooltip.forEach((e2) => {
            if (
              e1.TopicId == e2.ToppicId &&
              e1.SubTopicId == e2.SubToppicId &&
              e1.SubSubTopicId == e2.SubSubToppicId
            ) {
              // console.log('eeeeeeeeeeeee',e2)
              // console.log('ewwwwwwwwwwwwwww',e1)

              e2.Remarks = e1.Remark;
              if (this.FromLocal.PositionID !== 19) {
                if (e2.isCompetency == 0 && e1.Point !== 3) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  this.FromLocal.PositionID > 6 &&
                  this.FromLocal.PositionID !== 4 &&
                  e1.Point !== 3
                ) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  this.FromLocal.PositionID <= 6 &&
                  this.FromLocal.PositionID !== 4 &&
                  e1.Point !== 4
                ) {
                  e2.showRemark = true;
                }
                //RUN เพิ่ม condition การ default value
              } else {
                if (e2.isCompetency == 0 && e1.Point !== 3) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  e1.Point !== 4 &&
                  e1.SubSubTopicId.toString() == "2"
                ) {
                  e2.showRemark = true;
                } else if (
                  e2.isCompetency == 1 &&
                  e1.Point !== 3 &&
                  e1.SubSubTopicId.toString() !== "2"
                ) {
                  e2.showRemark = true;
                }
              }
            }
          });
        });
        this.setState({
          Tooltip: this.state.Tooltip,
          TooltipForEmp: this.state.TooltipForEmp,
        });
        this.AnsData.ansForm.forEach((e) => {
          this.AnsData.ansTotalClick.push({
            TopicId: e.TopicId,
            SubTopicId: e.SubTopicId,
            SubSubTopicId: e.SubSubTopicId,
            Point: e.Point,
            Remark: e.Remark,
            CalPoint: e.CalPoint,
          });
        });
        var temp = [];
        var temp2 = [];
        this.AnsData.ansTotalClick.forEach((e) => {
          if (this.AnsData.ansTotalClickTopic.length == 0) {
            this.AnsData.ansTotalClickTopic.push({
              TopicId: e.TopicId,
              CalPoint: e.CalPoint,
            });
          } else {
            temp = this.AnsData.ansTotalClickTopic.filter((e2) => {
              return e2.TopicId == e.TopicId;
            });
            if (temp.length == 0) {
              this.AnsData.ansTotalClickTopic.push({
                TopicId: e.TopicId,
                CalPoint: e.CalPoint,
              });
            } else {
              this.AnsData.ansTotalClickTopic.forEach((e3) => {
                if (e3.TopicId == e.TopicId) {
                  e3.CalPoint = e3.CalPoint + e.CalPoint;
                }
              });
            }
          }
        });
        this.AnsData.ansTotalClick.forEach((e) => {
          if (e.SubSubTopicId > 0) {
            if (this.AnsData.ansTotalClickSubSubTopic.length == 0) {
              this.AnsData.ansTotalClickSubSubTopic.push({
                TopicId: e.TopicId,
                SubTopicId: e.SubTopicId,
                SubSubTopicId: e.SubSubTopicId,
                CalPoint: e.CalPoint,
              });
            } else {
              temp = this.AnsData.ansTotalClickSubSubTopic.filter((e2) => {
                return e2.TopicId == e.TopicId && e2.SubTopicId == e.SubTopicId;
              });
              if (temp.length == 0) {
                this.AnsData.ansTotalClickSubSubTopic.push({
                  TopicId: e.TopicId,
                  SubTopicId: e.SubTopicId,
                  SubSubTopicId: e.SubSubTopicId,
                  CalPoint: e.CalPoint,
                });
              } else {
                this.AnsData.ansTotalClickSubSubTopic.forEach((e3) => {
                  if (
                    e3.TopicId == e.TopicId &&
                    e3.SubTopicId == e.SubTopicId
                  ) {
                    e3.CalPoint = e3.CalPoint + e.CalPoint;
                  }
                });
              }
            }
          }
        });
        var total = 0;
        this.AnsData.ansTotalClickTopic.forEach((e) => {
          total = total + e.CalPoint;
        });

        this.AnsData.TotalCalculate = total;
        ////////////////////////////////////////////////////////////////////////

        this.AnsData.ansFormAssessor.forEach((e) => {
          this.AnsData.ansTotalAssessorClick.push({
            TopicId: e.TopicId,
            SubTopicId: e.SubTopicId,
            SubSubTopicId: e.SubSubTopicId,
            Point: e.Point,
            Remark: e.Remark,
            CalPoint: e.CalPoint,
          });
        });
        var temp1 = [];
        var temp2 = [];
        this.AnsData.ansTotalAssessorClick.forEach((e) => {
          if (this.AnsData.ansTotalAssessorClickTopic.length == 0) {
            this.AnsData.ansTotalAssessorClickTopic.push({
              TopicId: e.TopicId,
              CalPoint: e.CalPoint,
            });
          } else {
            temp1 = this.AnsData.ansTotalAssessorClickTopic.filter((e2) => {
              return e2.TopicId == e.TopicId;
            });
            if (temp1.length == 0) {
              this.AnsData.ansTotalAssessorClickTopic.push({
                TopicId: e.TopicId,
                CalPoint: e.CalPoint,
              });
            } else {
              this.AnsData.ansTotalAssessorClickTopic.forEach((e3) => {
                if (e3.TopicId == e.TopicId) {
                  e3.CalPoint = e3.CalPoint + e.CalPoint;
                }
              });
            }
          }
        });
        this.AnsData.ansTotalAssessorClick.forEach((e) => {
          if (e.SubSubTopicId > 0) {
            if (this.AnsData.ansTotalAssessorClickSubSubTopic.length == 0) {
              this.AnsData.ansTotalAssessorClickSubSubTopic.push({
                TopicId: e.TopicId,
                SubTopicId: e.SubTopicId,
                SubSubTopicId: e.SubSubTopicId,
                CalPoint: e.CalPoint,
              });
            } else {
              temp1 = this.AnsData.ansTotalAssessorClickSubSubTopic.filter(
                (e2) => {
                  return (
                    e2.TopicId == e.TopicId && e2.SubTopicId == e.SubTopicId
                  );
                }
              );
              if (temp1.length == 0) {
                this.AnsData.ansTotalAssessorClickSubSubTopic.push({
                  TopicId: e.TopicId,
                  SubTopicId: e.SubTopicId,
                  SubSubTopicId: e.SubSubTopicId,
                  CalPoint: e.CalPoint,
                });
              } else {
                this.AnsData.ansTotalAssessorClickSubSubTopic.forEach((e3) => {
                  if (
                    e3.TopicId == e.TopicId &&
                    e3.SubTopicId == e.SubTopicId
                  ) {
                    e3.CalPoint = e3.CalPoint + e.CalPoint;
                  }
                });
              }
            }
          }
        });
        var total1 = 0;
        this.AnsData.ansTotalAssessorClickTopic.forEach((e) => {
          total1 = total1 + e.CalPoint;
        });

        this.AnsData.TotalAssessorCalculate = total1;

        console.log("this.state.tooltipforemp", this.state.TooltipForEmp);

        console.log("this.state.Toolstip.", this.state.Tooltip);
        this.setState({ tableData: result });
        this.spinnerControl();
      });
  }

  spinnerControl() {
    this.setState({ spinner: !this.state.spinner });
  }

  testarrayDupFunction(ToppicId, SubToppicId, SubSubToppicId) {
    // console.log("testarrayDupFunction");
    var tempDup = [];
    //RUN: ยัดใส่เป็น ToString ให้หมดเนื่องจากส่งไปsave กับ ส่งคืนมา มีค่าdatatype อิอัยยยยยยยยยย 16/04/2021
    var tempToppicId = ToppicId.toString();
    var tempSubToppicId = SubToppicId.toString();
    var tempSubSubToppicId = SubSubToppicId.toString();
    tempDup = this.AnsData.ansFormAssessor.filter((e) => {
      return (
        e.TopicId.toString() !== tempToppicId ||
        e.SubTopicId.toString() !== tempSubToppicId ||
        e.SubSubTopicId.toString() !== tempSubSubToppicId
      );
    });
    console.log("tempDup", tempDup);
    return tempDup;
  }

  handleChange = (
    ToppicId,
    SubToppicId,
    SubSubToppicId,
    value,
    indexfromRen,
    parentIndex,
    // RUN: เพิ่ม isCompetency เพื่อทำการ ตรวจสอบ comtency 14/04/2021
    isCompetency,
    // RUN: เพิ่ม WeightCriteria เพื่อทำการ คำนวน Score 14/04/2021
    WeightCriteria
  ) => {
    console.log("inchangeeeeeeeeeeee");

    var temp = [];
    var tempcalPoint = 0;
    temp = this.AnsData.ansFormAssessor.filter((e) => {
      return (
        e.TopicId == ToppicId &&
        e.SubTopicId == SubToppicId &&
        e.SubSubTopicId == SubSubToppicId
      );
    });

    //RUN : Flow การคิดคะแนน ใหม่สำหรับ เชิง สมรรถนะ 24/04/2021
    if (isCompetency == 1) {
      if (
        this.FromLocal.PositionID > 6 &&
        this.FromLocal.PositionID !== 4 &&
        value >= "3"
      ) {
        console.log("incondition 1 ");
        tempcalPoint = (parseFloat(WeightCriteria) / 5) * parseFloat(5);
      } else if (
        this.FromLocal.PositionID <= 6 &&
        this.FromLocal.PositionID !== 4 &&
        value >= "4"
      ) {
        console.log("incondition 2 ");

        tempcalPoint = (parseFloat(WeightCriteria) / 5) * parseFloat(5);
      } else if (
        this.FromLocal.PositionID > 6 &&
        this.FromLocal.PositionID !== 4 &&
        value < "3"
      ) {
        console.log("incondition 3 ");

        tempcalPoint = (parseFloat(WeightCriteria) / 3) * parseFloat(value);
      } else if (
        this.FromLocal.PositionID <= 6 &&
        this.FromLocal.PositionID !== 4 &&
        value < "4"
      ) {
        tempcalPoint = (parseFloat(WeightCriteria) / 4) * parseFloat(value);
      } else if (this.FromLocal.PositionID == 4 && value < "3") {
        tempcalPoint = (parseFloat(WeightCriteria) / 3) * parseFloat(value);
      } else if (this.FromLocal.PositionID == 4 && value >= "3") {
        tempcalPoint = (parseFloat(WeightCriteria) / 5) * parseFloat(5);
      }
    } else {
    }
    //RUN : Flow การคิดคะแนน ใหม่สำหรับ เชิง สมรรถนะ 24/04/2021
    if (isCompetency == 0) {
      console.log("incondition 4 ");

      tempcalPoint = (parseFloat(WeightCriteria) / 5) * parseFloat(value);
    }
    //RUN: condition สำหรับ ฝ่าย ศาสนกิจ
    if (this.FromLocal.PositionID == 19 && SubSubToppicId.toString() == "2") {
      console.log("incondition 5");

      if (value >= "4") {
        tempcalPoint = (parseFloat(WeightCriteria) / 5) * parseFloat(5);
      } else {
        tempcalPoint = (parseFloat(WeightCriteria) / 4) * parseFloat(value);
      }
    }

    console.log("tempcalPoint", tempcalPoint);
    if (temp.length == 0) {
      this.AnsData.ansFormAssessor.push({
        TopicId: ToppicId,
        SubTopicId: SubToppicId,
        SubSubTopicId: SubSubToppicId,
        Point: value, //ดึงคะแนนของหัวข้อมา
        Remark: "", //ดึงเหตุผลของหัวข้อมา
        // RUN: เพิ่ม WeightCriteria เพื่อทำการ คำนวน Score 14/04/2021
        CalPoint: tempcalPoint,
        isCompetency: isCompetency,
      });
    } else {
      this.AnsData.ansFormAssessor = this.testarrayDupFunction(
        ToppicId,
        SubToppicId,
        SubSubToppicId
      );

      this.AnsData.ansFormAssessor.push({
        TopicId: ToppicId,
        SubTopicId: SubToppicId,
        SubSubTopicId: SubSubToppicId,
        Point: value, //ดึงคะแนนของหัวข้อมา
        Remark: "", //ดึงเหตุผลของหัวข้อมา
        // RUN: เพิ่ม WeightCriteria เพื่อทำการ คำนวน Score 14/04/2021
        CalPoint: tempcalPoint,
        isCompetency: isCompetency,
      });
    }
    //RUN: เพิ่ม Condition การตรวจสอบ PositionID ให้เปิด/ปิด Remark ถูกต้อง 14/04/2021
    if (isCompetency == 1) {
      if (
        this.FromLocal.PositionID > 6 &&
        this.FromLocal.PositionID !== 4 &&
        value !== "3"
      ) {
        // Run: setState ให้ render ใหม่ได้ถูกต้อง 08/04/2021
        console.log("in if");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansFormAssessor.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } //RUN: เพิ่ม Condition else if การตรวจสอบ PositionID ให้เปิด/ปิด Remark ถูกต้อง 14/04/2021
      else if (
        //RUN: แก้ condition 22/04/2021
        this.FromLocal.PositionID <= 6 &&
        this.FromLocal.PositionID !== 4 &&
        value !== "4"
      ) {
        console.log("in else if");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansFormAssessor.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } else if (this.FromLocal.PositionID == "4" && value !== "3") {
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansForm.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } else {
        console.log("in else ");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: false,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
      }
    } else {
      if (value !== "3") {
        // Run: setState ให้ render ใหม่ได้ถูกต้อง 08/04/2021
        console.log("in if");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansFormAssessor.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } //RUN: เพิ่ม Condition else if การตรวจสอบ PositionID ให้เปิด/ปิด Remark ถูกต้อง 14/04/2021
      else {
        console.log("in else ");
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: false,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
      }
    }

    if (isCompetency == 1) {
      console.log("in 1 ");
      if (
        this.FromLocal.PositionID == "19" &&
        SubSubToppicId.toString() == "2" &&
        value == "4"
      ) {
        console.log("in 2 ");

        // Run: setState ให้ render ใหม่ได้ถูกต้อง 08/04/2021
        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: false,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansFormAssessor.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      } //RUN: เพิ่ม Condition else if การตรวจสอบ PositionID ให้เปิด/ปิด Remark ถูกต้อง 14/04/2021
      else if (
        //RUN: แก้ condition 22/04/2021
        this.FromLocal.PositionID == "19" &&
        SubSubToppicId.toString() == "2" &&
        value == "3"
      ) {
        console.log("in 3 ");

        this.setState((prevState) => ({
          Tooltip: prevState.Tooltip.map((showRemark, index) => {
            if (
              showRemark.SubToppicId == SubToppicId &&
              showRemark.SubSubToppicId == SubSubToppicId &&
              showRemark.ToppicId == ToppicId
            ) {
              return {
                ...showRemark,
                showRemark: true,
                Remarks: "",
              };
            } else {
              return {
                ...showRemark,
              };
            }
          }),
        }));
        this.AnsData.ansFormAssessor.forEach((e) => {
          if (
            e.TopicId == ToppicId &&
            e.SubTopicId == SubToppicId &&
            e.SubSubTopicId == SubSubToppicId
          ) {
            e.Remark = "";
          }
        });
      }
    }
    console.log(
      "this.loaslcosssssssssssssssssssssssssssss",
      this.AnsData.ansFormAssessor
    );
    this.TotalClickAssessorPointTopicFunction(
      ToppicId,
      SubToppicId,
      SubSubToppicId
    );
  };

  TotalClickPointTopicFunction(TopicId, SubTopicId, SubSubTopicId) {
    var tempArray = [];
    this.AnsData.ansForm.forEach((e) => {
      tempArray.push({
        TopicId: e.TopicId,
        SubTopicId: e.SubTopicId,
        SubSubTopicId: e.SubSubTopicId,
        Point: e.Point,
        Remark: e.Remark,
        CalPoint: e.CalPoint,
        isCompetency: e.isCompetency,
      });
    });
    var temp = [];
    var temp2 = [];
    tempArray.forEach((e) => {
      if (temp2.length == 0) {
        temp2.push({
          TopicId: e.TopicId,
          CalPoint: e.CalPoint,
        });
      } else {
        temp = temp2.filter((e2) => {
          return e2.TopicId == e.TopicId;
        });
        if (temp.length == 0) {
          temp2.push({
            TopicId: e.TopicId,
            CalPoint: e.CalPoint,
          });
        } else {
          temp2.forEach((e3) => {
            if (e3.TopicId == e.TopicId) {
              e3.CalPoint = e3.CalPoint + e.CalPoint;
            }
          });
        }
      }
    });
    this.AnsData.ansTotalClickTopic = temp2;

    var temp3 = [];
    var temp4 = [];
    tempArray.forEach((e) => {
      if (e.SubSubTopicId > 0) {
        if (temp3.length == 0) {
          temp3.push({
            TopicId: e.TopicId,
            SubTopicId: e.SubTopicId,
            SubSubTopicId: e.SubSubTopicId,
            CalPoint: e.CalPoint,
          });
        } else {
          temp4 = temp3.filter((e2) => {
            return e2.TopicId == e.TopicId && e2.SubTopicId == e.SubTopicId;
          });
          if (temp4.length == 0) {
            temp3.push({
              TopicId: e.TopicId,
              SubTopicId: e.SubTopicId,
              SubSubTopicId: e.SubSubTopicId,
              CalPoint: e.CalPoint,
            });
          } else {
            temp3.forEach((e3) => {
              if (e3.TopicId == e.TopicId && e3.SubTopicId == e.SubTopicId) {
                e3.CalPoint = e3.CalPoint + e.CalPoint;
              }
            });
          }
        }
      }
    });
    this.AnsData.ansTotalClickSubSubTopic = temp3;
    var total = 0;
    this.AnsData.ansTotalClickTopic.forEach((e) => {
      total = total + e.CalPoint;
    });

    this.AnsData.TotalCalculate = total;
  }

  TotalClickAssessorPointTopicFunction(TopicId, SubTopicId, SubSubTopicId) {
    var tempArray = [];
    this.AnsData.ansFormAssessor.forEach((e) => {
      tempArray.push({
        TopicId: e.TopicId,
        SubTopicId: e.SubTopicId,
        SubSubTopicId: e.SubSubTopicId,
        Point: e.Point,
        Remark: e.Remark,
        CalPoint: e.CalPoint,
        isCompetency: e.isCompetency,
      });
    });
    var temp = [];
    var temp2 = [];
    tempArray.forEach((e) => {
      if (temp2.length == 0) {
        temp2.push({
          TopicId: e.TopicId,
          CalPoint: e.CalPoint,
        });
      } else {
        temp = temp2.filter((e2) => {
          return e2.TopicId == e.TopicId;
        });
        if (temp.length == 0) {
          temp2.push({
            TopicId: e.TopicId,
            CalPoint: e.CalPoint,
          });
        } else {
          temp2.forEach((e3) => {
            if (e3.TopicId == e.TopicId) {
              e3.CalPoint = e3.CalPoint + e.CalPoint;
            }
          });
        }
      }
    });
    this.AnsData.ansTotalAssessorClickTopic = temp2;

    var temp3 = [];
    var temp4 = [];
    tempArray.forEach((e) => {
      if (e.SubSubTopicId > 0) {
        if (temp3.length == 0) {
          temp3.push({
            TopicId: e.TopicId,
            SubTopicId: e.SubTopicId,
            SubSubTopicId: e.SubSubTopicId,
            CalPoint: e.CalPoint,
          });
        } else {
          temp4 = temp3.filter((e2) => {
            return e2.TopicId == e.TopicId && e2.SubTopicId == e.SubTopicId;
          });
          if (temp4.length == 0) {
            temp3.push({
              TopicId: e.TopicId,
              SubTopicId: e.SubTopicId,
              SubSubTopicId: e.SubSubTopicId,
              CalPoint: e.CalPoint,
            });
          } else {
            temp3.forEach((e3) => {
              if (e3.TopicId == e.TopicId && e3.SubTopicId == e.SubTopicId) {
                e3.CalPoint = e3.CalPoint + e.CalPoint;
              }
            });
          }
        }
      }
    });
    this.AnsData.ansTotalAssessorClickSubSubTopic = temp3;
    var total = 0;
    this.AnsData.ansTotalAssessorClickTopic.forEach((e) => {
      total = total + e.CalPoint;
    });

    this.AnsData.TotalAssessorCalculate = total;
  }

  getDefaultScore(ToppicId, SubToppicId, SubSubToppicId) {
    var tempArray = [];
    tempArray = this.AnsData.ansFormAssessor.filter((e) => {
      return (
        e.TopicId == ToppicId &&
        e.SubTopicId == SubToppicId &&
        e.SubSubTopicId == SubSubToppicId
      );
    });
    if (tempArray.length > 0) {
      return tempArray[0].Point;
    } else {
      return null;
    }
  }

  decimalPointChange(item) {
    var temp = "";
    temp = item.toString();

    // console.log("temp", temp);
    if (temp.includes(".")) {
      return parseFloat(item).toFixed(2);
    } else {
      return item;
    }
  }

  splicingTitle(title) {
    var newtext = "";
    newtext = title.replace(/[0-9]/g, "");
    newtext = newtext.replace(/[.]/g, "");
    if (this.state.language == "TH") {
      newtext = newtext.replace(/\s/g, "");
    }
    return newtext;
  }

  handleRemark = (ToppicId, SubToppicId, SubSubToppicId, Remarks) => {
    this.AnsData.ansFormAssessor.forEach((old) => {
      if (
        old.TopicId == ToppicId &&
        old.SubTopicId == SubToppicId &&
        old.SubSubTopicId == SubSubToppicId
      ) {
        old.Remark = Remarks;
      }
    });
    // Run: Set State ให้Remark 09/04/2021

    this.setState((prevState) => ({
      Tooltip: prevState.Tooltip.map((RemarkValue, index) => {
        if (
          RemarkValue.SubToppicId == SubToppicId &&
          RemarkValue.SubSubToppicId == SubSubToppicId &&
          RemarkValue.ToppicId == ToppicId
        ) {
          return {
            ...RemarkValue,
            Remarks: Remarks,
          };
        } else {
          return {
            ...RemarkValue,
          };
        }
      }),
    }));
  };

  handleRemarkEmp = (ToppicId, SubToppicId, SubSubToppicId, Remarks) => {
    this.AnsData.ansForm.forEach((old) => {
      if (
        old.TopicId == ToppicId &&
        old.SubTopicId == SubToppicId &&
        old.SubSubTopicId == SubSubToppicId
      ) {
        old.Remark = Remarks;
      }
    });
    // Run: Set State ให้Remark 09/04/2021

    this.setState((prevState) => ({
      TooltipForEmp: prevState.TooltipForEmp.map((RemarkValue, index) => {
        if (
          RemarkValue.SubToppicId == SubToppicId &&
          RemarkValue.SubSubToppicId == SubSubToppicId &&
          RemarkValue.ToppicId == ToppicId
        ) {
          return {
            ...RemarkValue,
            Remarks: Remarks,
          };
        } else {
          return {
            ...RemarkValue,
          };
        }
      }),
    }));
  };

  renderTable() {
    //Run: เพิ่ม การแสดง cal คะแนน 14/04/2021
    // this.AnsData.ansTotalClickTopic
    // console.log('this.ARRR', this.state.Tooltip)
    // console.log('this.ini', this.initArrays.SubSubTopicArr)
    console.log(
      "this.AnsData.ansTotalClickSubSubTopic",
      this.AnsData.ansTotalClickSubSubTopic
    );

    const totalclickPointSubSubTopic = this.AnsData.ansTotalClickSubSubTopic.map(
      ({ TopicId, CalPoint, SubTopicId, SubSubTopicId }, Index) => (
        <div key={Index} TopicId={TopicId} SubTopicId={SubTopicId}>
          {/* {CalPoint} */}
          {this.decimalPointChange(CalPoint)}
        </div>
      )
    );

    const totalclickPointAssessorSubSubTopic = this.AnsData.ansTotalAssessorClickSubSubTopic.map(
      ({ TopicId, CalPoint, SubTopicId, SubSubTopicId }, Index) => (
        <div key={Index} TopicId={TopicId} SubTopicId={SubTopicId}>
          {/* {CalPoint} */}
          {this.decimalPointChange(CalPoint)}
        </div>
      )
    );

    const totalclickpointTopic = this.AnsData.ansTotalClickTopic.map(
      ({ TopicId, CalPoint }, Index) => (
        <div key={Index} relateTopicID={TopicId}>
          {/* {CalPoint}
           */}
          {this.decimalPointChange(CalPoint)}
        </div>
      )
    );

    const totalclickassessorpointTopic = this.AnsData.ansTotalAssessorClickTopic.map(
      ({ TopicId, CalPoint }, Index) => (
        <div key={Index} relateTopicID={TopicId}>
          {/* {CalPoint}
           */}
          {this.decimalPointChange(CalPoint)}
        </div>
      )
    );

    const listCalScore = this.AnsData.ansForm.map(
      (
        { TopicId, SubTopicId, SubSubTopicId, CalPoint, isCompetency },
        Index
      ) => (
        <div
          key={Index}
          relateTopicID={TopicId}
          relateSubToppicId={SubTopicId}
          relatedSubSubToppicID={SubSubTopicId}
          relatedisCom={isCompetency}
        >
          <div>
            {/* {CalPoint} */}

            {this.decimalPointChange(CalPoint)}
          </div>
        </div>
      )
    );

    console.log(
      "this.sssssssssssssssssss",
      listCalScore.filter((e) => {
        return (
          e.props.relateSubToppicId == 0 &&
          e.props.relateTopicID == 0 &&
          e.props.relatedSubSubToppicID == 0
        );
      })
    );

    const remarkSubTopic = this.AnsData.ansForm.map(
      ({ TopicId, SubTopicId, SubSubTopicId, Remark }, Index) => (
        <div
          key={Index}
          relateTopicID={TopicId}
          relateSubToppicId={SubTopicId}
          relatedSubSubToppicID={SubSubTopicId}
        >
          <p> {Remark} </p>
        </div>
      )
    );

    const listAssessorCalScore = this.AnsData.ansFormAssessor.map(
      ({ TopicId, SubTopicId, SubSubTopicId, CalPoint }, Index) => (
        <div
          key={Index}
          relateTopicID={TopicId}
          relateSubToppicId={SubTopicId}
          relatedSubSubToppicID={SubSubTopicId}
        >
          <div>
            {/* {CalPoint} */}
            {this.decimalPointChange(CalPoint)}
          </div>
        </div>
      )
    );

    //Run: เพิ่ม listweight ของ topic หลัก 14/04/2021
    const listWeightsTotal = this.state.weight.map(
      (
        { SubSubToppicId, SubToppicId, ToppicId, WeightCriteria, IsMainTopic },
        Index
      ) => (
        <div
          key={Index}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={SubSubToppicId}
          IsMainTopic={IsMainTopic}
        >
          <div>{WeightCriteria}</div>
        </div>
      )
    );
    //Run: เพิ่ม weight 14/04/2021
    const listofWeight = this.state.Tooltip.map(
      (
        { SubSubToppicId, SubToppicId, ToppicId, Tooltip1TH, WeightCriteria },
        Counts
      ) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={SubSubToppicId}
          TooltipInfo={Tooltip1TH}
        >
          {<div>{WeightCriteria}</div>}
        </div>
      )
    );

    const listbuttonSubSubTopic = this.state.Tooltip.map(
      (
        {
          SubSubToppicId,
          SubToppicId,
          ToppicId,
          Tooltip5TH,
          Tooltip4TH,
          Tooltip3TH,
          Tooltip2TH,
          Tooltip1TH,
          Tooltip5EN,
          Tooltip4EN,
          Tooltip3EN,
          Tooltip2EN,
          Tooltip1EN,
          showRemark,
          //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
          WeightCriteria,
          //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
          isCompetency,
          Remarks,
        },
        Counts
      ) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={SubSubToppicId}
          TooltipInfo={Tooltip1TH}
        >
          {Tooltip1TH && SubSubToppicId > 0 && (
            <div
              onChange={(e) => {
                this.handleChange(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId,
                  e.target.value,
                  Counts,
                  showRemark,
                  //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
                  isCompetency,
                  //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
                  WeightCriteria
                );
              }}
            >
              <Radio.Group
                name="subsubtopic"
                buttonStyle="solid"
                defaultValue={this.getDefaultScore(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId
                )}
                disabled
              >
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip5TH : Tooltip5EN}
                >
                  <Radio.Button value={5}>5</Radio.Button>
                </Tooltip>
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip4TH : Tooltip4EN}
                >
                  <Radio.Button value={4}>4</Radio.Button>
                </Tooltip>
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip3TH : Tooltip3EN}
                >
                  <Radio.Button value={3}>3</Radio.Button>
                </Tooltip>
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip2TH : Tooltip2EN}
                >
                  <Radio.Button value={2}>2</Radio.Button>
                </Tooltip>
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip1TH : Tooltip1EN}
                >
                  <Radio.Button value={1}>1</Radio.Button>
                </Tooltip>
              </Radio.Group>
            </div>
          )}
        </div>
      )
    );

    const listbuttonSubTopic = this.state.Tooltip.map(
      (
        {
          SubSubToppicId,
          SubToppicId,
          ToppicId,
          Tooltip5TH,
          Tooltip4TH,
          Tooltip3TH,
          Tooltip2TH,
          Tooltip1TH,
          Tooltip5EN,
          Tooltip4EN,
          Tooltip3EN,
          Tooltip2EN,
          Tooltip1EN,
          showRemark,
          //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
          WeightCriteria,
          //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
          isCompetency,
          Remarks,
        },
        Counts
      ) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={0}
          TooltipInfo={Tooltip1TH}
          style={{ marginLeft: 15 }}
        >
          {Tooltip1TH && SubSubToppicId == 0 && (
            <div
              onChange={(e) => {
                this.handleChange(
                  ToppicId,
                  SubToppicId,
                  0,
                  e.target.value,
                  Counts,
                  showRemark,
                  //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
                  isCompetency,
                  //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
                  WeightCriteria
                );
              }}
            >
              <Radio.Group
                name="subsubtopic"
                buttonStyle="solid"
                defaultValue={this.getDefaultScore(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId
                )}
                disabled
              >
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip5TH : Tooltip5EN}
                >
                  <Radio.Button value={5}>5</Radio.Button>
                </Tooltip>
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip4TH : Tooltip4EN}
                >
                  <Radio.Button value={4}>4</Radio.Button>
                </Tooltip>
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip3TH : Tooltip3EN}
                >
                  <Radio.Button value={3}>3</Radio.Button>
                </Tooltip>
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip2TH : Tooltip2EN}
                >
                  <Radio.Button value={2}>2</Radio.Button>
                </Tooltip>
                <Tooltip
                  placement="topLeft"
                  title={this.state.language == "TH" ? Tooltip1TH : Tooltip1EN}
                >
                  <Radio.Button value={1}>1</Radio.Button>
                </Tooltip>
              </Radio.Group>
            </div>
          )}
        </div>
      )
    );

    const listRemarkSubSubTopic = this.state.Tooltip.map(
      (
        {
          SubSubToppicId,
          SubToppicId,
          ToppicId,
          Tooltip5TH,
          Tooltip4TH,
          Tooltip3TH,
          Tooltip2TH,
          Tooltip1TH,
          Tooltip5EN,
          Tooltip4EN,
          Tooltip3EN,
          Tooltip2EN,
          Tooltip1EN,
          showRemark,
          //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
          WeightCriteria,
          //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
          isCompetency,
          Remarks,
        },
        Counts
      ) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={SubSubToppicId}
          TooltipInfo={Tooltip1TH}
        >
          {Tooltip1TH && SubSubToppicId > 0 && showRemark == true && (
            <div
              onChange={(e) => {
                this.handleRemark(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId,
                  e.target.value
                );
              }}
            >
              <b> เหตุผล: </b> <br />
              {Remarks}
            </div>
          )}
        </div>
      )
    );

    const listRemarkSubSubTopicEmp = this.state.TooltipForEmp.map(
      (
        {
          SubSubToppicId,
          SubToppicId,
          ToppicId,
          Tooltip5TH,
          Tooltip4TH,
          Tooltip3TH,
          Tooltip2TH,
          Tooltip1TH,
          Tooltip5EN,
          Tooltip4EN,
          Tooltip3EN,
          Tooltip2EN,
          Tooltip1EN,
          showRemark,
          //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
          WeightCriteria,
          //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
          isCompetency,
          Remarks,
        },
        Counts
      ) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={SubSubToppicId}
          TooltipInfo={Tooltip1TH}
        >
          {Tooltip1TH && SubSubToppicId > 0 && showRemark == true && (
            <div
              onChange={(e) => {
                this.handleRemarkEmp(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId,
                  e.target.value
                );
              }}
            >
              <Text>{Remarks}</Text>
            </div>
          )}
        </div>
      )
    );

    const listRemarkSubTopic = this.state.Tooltip.map(
      (
        {
          SubSubToppicId,
          SubToppicId,
          ToppicId,
          Tooltip5TH,
          Tooltip4TH,
          Tooltip3TH,
          Tooltip2TH,
          Tooltip1TH,
          Tooltip5EN,
          Tooltip4EN,
          Tooltip3EN,
          Tooltip2EN,
          Tooltip1EN,
          showRemark,
          //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
          WeightCriteria,
          //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
          isCompetency,
          Remarks,
        },
        Counts
      ) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={0}
          TooltipInfo={Tooltip1TH}
          style={{ marginLeft: 15 }}
        >
          {Tooltip1TH && SubSubToppicId == 0 && (
            <div
              onChange={(e) => {
                this.handleChange(
                  ToppicId,
                  SubToppicId,
                  0,
                  e.target.value,
                  Counts,
                  showRemark,
                  //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
                  isCompetency,
                  //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
                  WeightCriteria
                );
              }}
            ></div>
          )}
          {Tooltip1TH && SubSubToppicId == 0 && showRemark == true && (
            <div
              onChange={(e) => {
                this.handleRemark(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId,
                  e.target.value
                );
              }}
            >
              <b> เหตุผล: </b> <br />
              {Remarks}
            </div>
          )}
        </div>
      )
    );

    const listRemarkSubTopicEmp = this.state.TooltipForEmp.map(
      (
        {
          SubSubToppicId,
          SubToppicId,
          ToppicId,
          Tooltip5TH,
          Tooltip4TH,
          Tooltip3TH,
          Tooltip2TH,
          Tooltip1TH,
          Tooltip5EN,
          Tooltip4EN,
          Tooltip3EN,
          Tooltip2EN,
          Tooltip1EN,
          showRemark,
          //RUN: เพิ่มตัวแปร WeightCriteria เพื่อใช้ในการคำนวน 14/04/2021
          WeightCriteria,
          //RUN: เพิ่มตัวแปร isCompetency เพื่อตรวจสอบcompetency evaluation 18/04/2021
          isCompetency,
          Remarks,
        },
        Counts
      ) => (
        <div
          key={Counts}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={0}
          TooltipInfo={Tooltip1TH}
          style={{ marginLeft: 15 }}
        >
          {Tooltip1TH && SubSubToppicId == 0 && showRemark == true && (
            <div
              onChange={(e) => {
                this.handleRemarkEmp(
                  ToppicId,
                  SubToppicId,
                  SubSubToppicId,
                  e.target.value
                );
              }}
            >
              {/* <Text>{Remarks}</Text> */}
              <Text>{Remarks}</Text>
            </div>
          )}
        </div>
      )
    );

    const listSubSubTopics = this.initArrays.SubSubTopicArr.map(
      (
        {
          TitleTH,
          TitleEN,
          SubToppicId,
          ToppicId,
          SubSubToppicId,
          DescriptionTH,
          DescriptionEN,
        },
        Indexes
      ) => (
        <div
          key={Indexes}
          ToppicIDs={ToppicId}
          SubIDs={SubToppicId}
          SubSubTopicId={SubSubToppicId}
          style={{
            padding: "15px 0px",
            paddingLeft: 20,
            paddingRight: 20,
            borderBottom: "1px solid #DCDCDC",
          }}
        >
          <Row>
            {this.state.language == "TH" ? (
              <Col span={5}>
                <p style={{ paddingLeft: "20px", paddingRight: "40px" }}>
                  <b>{TitleTH.slice(0,-1)} </b>
                  {/* {DescriptionTH} */}
                </p>
              </Col>
            ) : (
              <Col span={5}>
                <p style={{ paddingLeft: "20px", paddingRight: "40px" }}>
                  <b>{TitleEN.slice(0,-1)} </b>
                  {/* {DescriptionEN} */}
                </p>
              </Col>
            )}
            {/* Run: เพิ่มการใส่ น้ำหนักคะแนน 14/04/2021 */}
            <Col
              style={{
                textAlign: "center",
              }}
              span={2}
            >
              {listofWeight.filter((e) => {
                return (
                  e.props.relateSubToppicId == SubToppicId &&
                  e.props.relateTopicID == ToppicId &&
                  e.props.relatedSubSubToppicID == SubSubToppicId
                );
              })}
            </Col>

            <Col
              xs={3}
              sm={3}
              md={6}
              lg={6}
              xl={6}
              style={{ textAlign: "center" }}
            >
              {listbuttonSubSubTopic.filter((e) => {
                return (
                  e.props.relateSubToppicId == SubToppicId &&
                  e.props.relateTopicID == ToppicId &&
                  e.props.TooltipInfo !== "" &&
                  e.props.relatedSubSubToppicID == SubSubToppicId
                );
              })}
            </Col>
            {/* Run: เพิ่มการใส่ คะแนน Cal 14/04/2021 */}
            <Col
              style={{
                textAlign: "center",
                borderRight: "1px solid",
              }}
              span={2}
            >
              {listAssessorCalScore.filter((e) => {
                return (
                  e.props.relateSubToppicId == SubToppicId &&
                  e.props.relateTopicID == ToppicId &&
                  e.props.relatedSubSubToppicID == SubSubToppicId
                );
              })}
            </Col>
            <Col
              style={{
                textAlign: "center",
              }}
              span={2}
            >
              {listCalScore.filter((e) => {
                return (
                  e.props.relateSubToppicId == SubToppicId &&
                  e.props.relateTopicID == ToppicId &&
                  e.props.relatedSubSubToppicID == SubSubToppicId
                );
              }).length !== 0
                ? listCalScore.filter((e) => {
                    return (
                      e.props.relateSubToppicId == SubToppicId &&
                      e.props.relateTopicID == ToppicId &&
                      e.props.relatedSubSubToppicID == SubSubToppicId
                    );
                  })
                : "0"}
            </Col>
            <Col span={4}>
              {listRemarkSubSubTopicEmp.filter((e) => {
                return (
                  e.props.relateSubToppicId == SubToppicId &&
                  e.props.relateTopicID == ToppicId &&
                  e.props.TooltipInfo !== "" &&
                  e.props.relatedSubSubToppicID == SubSubToppicId
                );
              })}
            </Col>
          </Row>

          {/* {เพิ่ม div remark} */}

          <div style={{ width: "100%" }}>
            {listRemarkSubSubTopic.filter((e) => {
              return (
                e.props.relateSubToppicId == SubToppicId &&
                e.props.relateTopicID == ToppicId &&
                e.props.TooltipInfo !== "" &&
                e.props.relatedSubSubToppicID == SubSubToppicId
              );
            })}
          </div>
        </div>
      )
    );

    const listSubTopics = this.initArrays.SubTopicArr.map(
      (
        {
          TitleTH,
          TitleEN,
          SubToppicId,
          ToppicId,
          SubSubToppicId,
          DescriptionTH,
          DescriptionEN,
        },
        Index
      ) => (
        <div
          key={Index}
          ToppicID={ToppicId}
          SubID={SubToppicId}
          SUSUSUS={SubSubToppicId}
        >
          <div
            style={{
              padding: "10px 20px 10px 20px",
              borderBottom: "1px solid #DCDCDC",
            }}
          >
            <Row>
              {this.state.language == "TH" ? (
                <Col span={5} style={{ backgroundColor: "#" }}>
                  <p>
                    <b> {TitleTH.slice(0,-1)} </b>          
                    {/* {DescriptionTH} */}
           
                  </p>
                </Col>
              ) : (
                <Col span={5} style={{ backgroundColor: "#" }}>
                  <p>
                    <b> {TitleEN.slice(0,-1)}  </b>     
                     {/* {DescriptionEN} */}
                  </p>
                </Col>
              )}
              {/* Run: เพิ่มการใส่ น้ำหนักคะแนน 14/04/2021 */}
              <Col
                style={{
                  textAlign: "center",
                }}
                span={2}
              >
                {listofWeight.filter((e) => {
                  return (
                    e.props.relateSubToppicId == SubToppicId &&
                    e.props.relateTopicID == ToppicId &&
                    e.props.relatedSubSubToppicID == 0
                  );
                })}
              </Col>
              <Col
                xs={3}
                sm={10}
                md={6}
                lg={6}
                xl={6}
                style={{ textAlign: "center" }}
              >
                {listbuttonSubTopic.filter((e) => {
                  return (
                    e.props.relateSubToppicId == SubToppicId &&
                    e.props.relateTopicID == ToppicId &&
                    e.props.TooltipInfo !== ""
                  );
                })}
              </Col>
              {/* Run: เพิ่มการ ใส่ คะแนน Cal 14/04/2021*/}
              <Col
                style={{ textAlign: "center", borderRight: "1px solid" }}
                span={2}
              >
                {listAssessorCalScore.filter((e) => {
                  return (
                    e.props.relateSubToppicId == SubToppicId &&
                    e.props.relateTopicID == ToppicId &&
                    e.props.relatedSubSubToppicID == 0
                  );
                })}
              </Col>
              <Col style={{ textAlign: "center" }} span={2}>
                {listCalScore.filter((e) => {
                  return (
                    e.props.relateSubToppicId == SubToppicId &&
                    e.props.relateTopicID == ToppicId &&
                    e.props.relatedSubSubToppicID == 0
                  );
                }).length > 0
                  ? listCalScore.filter((e) => {
                      return (
                        e.props.relateSubToppicId == SubToppicId &&
                        e.props.relateTopicID == ToppicId &&
                        e.props.relatedSubSubToppicID == 0
                      );
                    })
                  : DescriptionTH !== ""
                  ? "0"
                  : null}
              </Col>
              <Col span={4}>
                {listRemarkSubTopicEmp.filter((e) => {
                  return (
                    e.props.relateSubToppicId == SubToppicId &&
                    e.props.relateTopicID == ToppicId &&
                    e.props.TooltipInfo !== ""
                  );
                })}
              </Col>
            </Row>

            {/* {เพิ่ม div remark} */}

            <div style={{ width: "100%" }}>
              {listRemarkSubTopic.filter((e) => {
                return (
                  e.props.relateSubToppicId == SubToppicId &&
                  e.props.relateTopicID == ToppicId &&
                  e.props.TooltipInfo !== ""
                );
              })}
            </div>
          </div>

          <div>
            {listSubSubTopics.filter((e) => {
              return e.props.SubIDs == SubToppicId;
            })}
          </div>

          <div
            style={{
              padding: "10px 20px 10px 20px",
              borderBottom: "1px solid #DCDCDC",
              background: "#F2F2F2",
            }}
          >
            <Row>
              {DescriptionTH == "" && this.state.language == "TH" ? (
                <Col span={5}>
                  <p> รวม{this.splicingTitle(TitleTH)}</p>
                </Col>
              ) : null}
              {DescriptionTH == "" && this.state.language == "EN" ? (
                <Col span={5}>
                  <p> {this.splicingTitle(TitleEN)} Total</p>
                </Col>
              ) : null}
              {DescriptionTH == "" ? (
                <Col
                  style={{
                    textAlign: "center",
                  }}
                  span={2}
                >
                  {listofWeight.filter((e) => {
                    return (
                      e.props.relateSubToppicId == SubToppicId &&
                      e.props.relateTopicID == ToppicId &&
                      e.props.relatedSubSubToppicID == 0
                    );
                  })}
                </Col>
              ) : null}
              <Col
                xs={3}
                sm={3}
                md={6}
                lg={6}
                xl={6}
                style={{ textAlign: "center" }}
              ></Col>
              {DescriptionTH == "" ? (
                <Col
                  style={{ textAlign: "center", borderRight: "1px solid" }}
                  span={2}
                >
                  {totalclickPointAssessorSubSubTopic.filter((e) => {
                    return (
                      e.props.TopicId == ToppicId &&
                      e.props.SubTopicId == SubToppicId
                    );
                  })}
                </Col>
              ) : (
                <Col
                  style={{ textAlign: "center", borderRight: "1px solid" }}
                  span={2}
                ></Col>
              )}
              {DescriptionTH == "" ? (
                <Col style={{ textAlign: "center" }} span={2}>
                  {totalclickPointSubSubTopic.filter((e) => {
                    return (
                      e.props.TopicId == ToppicId &&
                      e.props.SubTopicId == SubToppicId
                    );
                  })}
                </Col>
              ) : (
                <Col style={{ textAlign: "center" }} span={2}></Col>
              )}
            </Row>
          </div>
        </div>
      )
    );

    const titleTopic = this.initArrays.TopicsArr.map(
      ({ ToppicId, TitleTH, TitleEN }, Order) => (
        <div key={Order} relateTopicID={ToppicId}>
          {this.state.language == "TH" ? (
            <div>รวม{this.splicingTitle(TitleTH)}</div>
          ) : (
            <div>{this.splicingTitle(TitleEN)} Total</div>
          )}
        </div>
      )
    );

    const listItems = this.initArrays.TopicsArr.map(
      ({ ToppicId, TitleTH, TitleEN, DescriptionTH, DescriptionEN }, Order) => (
        <div>
          <div
            style={{
              padding: "10px 15px",
              borderBottom: "1px solid #DCDCDC",
              background: "#E8F7FF",
            }}
          >
            <Row>
              {this.state.language == "TH" ? (
                <Col span={5}>
                  <p key={ToppicId}>
                    <b> {TitleTH} </b>
                    {DescriptionTH} 
                  </p>
                </Col>
              ) : (
                <Col span={5}>
                  <p key={ToppicId}>
                    <b> {TitleEN} </b>
                    {DescriptionEN}
                  </p>
                </Col>
              )}
              <Col
                style={{
                  textAlign: "center",
                }}
                span={2}
              >
                {/* Run: เพิ่มการ ใส่ น้ำหนักคะแนนสำหรับ Topic 14/04/2021*/}

                {listWeightsTotal.filter((e) => {
                  return (
                    e.props.relateSubToppicId == 0 &&
                    e.props.relateTopicID == ToppicId &&
                    e.props.relatedSubSubToppicID == 0 &&
                    e.props.IsMainTopic
                  );
                })}
              </Col>
            </Row>
          </div>

          <div>
            {listSubTopics.filter((e) => {
              return e.props.ToppicID == ToppicId;
            })}
          </div>
          <div
            style={{
              padding: "10px 20px 10px 20px",
              borderBottom: "1px solid #DCDCDC",
              background: "#F2F2F2",
            }}
          >
            <Row>
              <Col span={5}>
                <p key={ToppicId}>
                  {titleTopic.filter((e) => {
                    return e.props.relateTopicID == ToppicId;
                  })}
                </p>
              </Col>

              <Col
                style={{
                  textAlign: "center",
                }}
                span={2}
              >
                {listWeightsTotal.filter((e) => {
                  return (
                    e.props.relateSubToppicId == 0 &&
                    e.props.relateTopicID == ToppicId &&
                    e.props.relatedSubSubToppicID == 0 &&
                    e.props.IsMainTopic
                  );
                })}
              </Col>

              <Col xs={3} sm={3} md={6} lg={6} xl={6}></Col>

              <Col
                span={2}
                style={{ textAlign: "center", borderRight: "1px solid" }}
              >
                {totalclickassessorpointTopic.filter((e) => {
                  return e.props.relateTopicID == ToppicId;
                })}
              </Col>
              <Col span={2} style={{ textAlign: "center" }}>
                {totalclickpointTopic.filter((e) => {
                  return e.props.relateTopicID == ToppicId;
                })}
              </Col>
            </Row>
          </div>
        </div>
      )
    );

    return (
      <div style={{ widht: "80%", border: "1px solid #DCDCDC" }}>
        <Affix offsetTop={158}>
          <div
            style={{
              padding: 15,
              backgroundColor: "#30BAFF",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {this.state.language == "TH" ? (
              <Row>
                <Col span={5}>เกณฑ์การประเมินผล</Col>
                <Col span={2}> น้ำหนักคะแนน </Col>
                <Col xs={3} sm={3} md={6} lg={6} xl={6}>
                  ระดับคะแนน
                </Col>
                <Col span={2} style={{ borderRight: "1px solid" }}>
                  คะแนน
                </Col>
                <Col span={2}> ผลการประเมินตนเอง</Col>
                <Col span={4}> เหตุผลการประเมินตนเอง</Col>
              </Row>
            ) : (
              <Row>
                <Col span={5}> Criteria </Col>
                <Col span={2}> Score weight </Col>
                <Col span={6}> Score </Col>
                <Col span={2} style={{ borderRight: "1px solid" }}>
                  Total
                </Col>
                <Col span={2}> Self Assessment Score</Col>
                <Col span={4}> Self Assessment Remark</Col>
              </Row>
            )}
          </div>
        </Affix>

        <div>{listItems}</div>
        <div
          style={{
            padding: "10px 20px 10px 20px",
            borderBottom: "1px solid #DCDCDC",
            background: "#EAEAEA",
          }}
        >
          <Row>
            <Col span={5}>
              <p>
                {this.state.language == "TH" ? (
                  <b>รวมคะแนนที่ได้</b>
                ) : (
                  <b>Total Score</b>
                )}
              </p>
            </Col>
            <Col
              span={2}
              style={{
                textAlign: "center",
              }}
            >
              100
            </Col>

            <Col
              xs={3}
              sm={3}
              md={6}
              lg={6}
              xl={6}
              style={{
                textAlign: "center",
              }}
            />

            <Col
              span={2}
              style={{
                textAlign: "center",
                borderRight: "1px solid",
              }}
            >
              {this.decimalPointChange(this.AnsData.TotalAssessorCalculate)}
            </Col>
            <Col
              span={2}
              style={{
                textAlign: "center",
              }}
            >
              {this.decimalPointChange(this.AnsData.TotalCalculate)}
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  renderSignBoxTH() {
    //Run: เพิ่ม listweight ของ topic หลัก 14/04/2021
    const listWeightsTotal = this.state.weight.map(
      (
        { SubSubToppicId, SubToppicId, ToppicId, WeightCriteria, IsMainTopic },
        Index
      ) => (
        <div
          key={Index}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={SubSubToppicId}
          IsMainTopic={IsMainTopic}
        >
          <div>{WeightCriteria}</div>
        </div>
      )
    );

    const listItems = this.initArrays.TopicsArr.map(
      ({ ToppicId, TitleTH, TitleEN, DescriptionTH, DescriptionEN }, Order) => (
        <div
        // style={{
        //   padding: "10px 15px",
        //   borderBottom: "1px solid #DCDCDC",
        //   background: "#E8F7FF",
        // }}
        >
          {/* Run: เพิ่มการ ใส่ น้ำหนักคะแนนสำหรับ Topic 14/04/2021*/}

          {listWeightsTotal.filter((e) => {
            return (
              e.props.relateSubToppicId == 0 &&
              e.props.relateTopicID == ToppicId &&
              e.props.relatedSubSubToppicID == 0 &&
              e.props.IsMainTopic
            );
          })}
        </div>
      )
    );

    const totalclickassessorpointTopic = this.AnsData.ansTotalAssessorClickTopic.map(
      ({ TopicId, CalPoint }, Index) => (
        <div key={Index} relateTopicID={TopicId}>
          {/* {CalPoint}
           */}
          {this.decimalPointChange(CalPoint)}
        </div>
      )
    );

    const listItems2 = this.initArrays.TopicsArr.map(
      ({ ToppicId, TitleTH, TitleEN, DescriptionTH, DescriptionEN }, Order) => (
        <div
        // style={{
        //   padding: "10px 15px",
        //   borderBottom: "1px solid #DCDCDC",
        //   background: "#E8F7FF",
        // }}
        >
          {/* Run: เพิ่มการ ใส่ น้ำหนักคะแนนสำหรับ Topic 14/04/2021*/}

          {totalclickassessorpointTopic.filter((e) => {
                  return e.props.relateTopicID == ToppicId;
                })}
        </div>
      )
    );

    console.log("listItems2 in sign box ", listItems2);

    return (
      <div>
        <Row>
          <Col span={16}>
            <table id="table-two">
              <tr>
                <th style={{ width: "70%", padding: 10 }}>เกณฑ์การประเมินผล</th>
                <th style={{ padding: 10 }}> น้ำหนักคะแนน </th>
                <th style={{ padding: 10 }}> ระดับคะแนน </th>
              </tr>
              <tr>
                <td>1. ภาระตามตำแหน่งงาน</td>
                <td>{listItems[0]}</td>
                <td>{listItems2[0]}</td>
              </tr>
              <tr>
                <td>2. ภาระงานอื่น</td>
                <td>{listItems[1]}</td>
                <td>{listItems2[1]}</td>
              </tr>
              <tr>
                <td>3. คุณภาพงาน</td>
                <td>{listItems[2]}</td>
                <td>{listItems2[2]}</td>
              </tr>
              <tr>
                <td>4. ความสามารถเชิงสมรรถนะ</td>
                <td>{listItems[3]}</td>
                <td>{listItems2[3]}</td>
              </tr>
              <tr>
                <td>
                  <b>คะแนนรวม (1 + 2 + 3 + 4) </b>
                </td>
                <td>
                  <b> 100.00 </b>
                </td>
                <td>
                  <b>{this.decimalPointChange(this.AnsData.TotalAssessorCalculate)}</b>
                </td>
              </tr>
            </table>
          </Col>

          <Col span={8}>
            <div style={{ border: "2px solid black", padding: 15 }}>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <b style={{ fontSize: 14, marginBottom: 15 }}>
                  ความคิดเห็นของผู้ประเมิน 
                </b>
                <br />
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <br />
                <div style={{ textAlign: "center" }}>
                  <p> ลงชื่อ _________________________________</p>
                  <p> {"( " + this.props.location.state.record.Assessor[0].TitleTH + " " + this.props.location.state.record.Assessor[0].FirstNameTH + " " + this.props.location.state.record.Assessor[0].LastNameTH + " )" }</p>
                  <p> ตำแหน่ง _______________________________</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={8}>
            <div style={{ border: "2px solid black", padding: 15 }}>
              <b style={{ fontSize: 14, marginBottom: 15 }}>
                ความคิดเห็นของคณบดี / ผู้อำนวยการ 
              </b>

              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <br />
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <br />
                <div style={{ textAlign: "center" }}>
                  <p> ลงชื่อ _________________________________</p>
                  <p> {"( " + this.props.location.state.record.Admin[0].TitleTH + " " + this.props.location.state.record.Admin[0].FirstNameTH + " " + this.props.location.state.record.Admin[0].LastNameTH + " )" }</p>
                  <p> ตำแหน่ง _______________________________</p>
                </div>
              </div>
            </div>
          </Col>

          <Col span={8}>
            <div style={{ border: "2px solid black", padding: 15 }}>
              <b style={{ fontSize: 14, marginBottom: 15 }}>
                ความคิดเห็นของรองอธิการบดี / ผู้ช่วยอธิการบดี 
              </b>

              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <br />
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <p>
                  __________________________________________________________________________________________________________
                </p>
                <br />
                <div style={{ textAlign: "center" }}>
                  <p> ลงชื่อ _________________________________</p>
                  <p> {"( " + this.props.location.state.record.Confirm[0].TitleTH + " " + this.props.location.state.record.Confirm[0].FirstNameTH + " " + this.props.location.state.record.Confirm[0].LastNameTH + " )" }</p>
                  <p> ตำแหน่ง _______________________________</p>
                </div>
              </div>
            </div>
          </Col>

          <Col span={8}>
            <div style={{ border: "2px solid black", padding: 15 }}>
              <b style={{ fontSize: 14, marginBottom: 15 }}>
                ความคิดเห็นของรักษาการอธิการบดี 
              </b>
              <br />
              <br />
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <br />

                <ul class="a">
  <li>อนุมัติ</li>
  <li>ไม่อนุมัติ ........................................................................................</li>
</ul>


                <br />
                <br />
                <div style={{ textAlign: "center" }}>
                  <p> ลงชื่อ _________________________________</p>
                  <p>
                    ( นายอภิชา อินสุวรรณ ) <br/>
                    ตำแหน่ง รักษาการอธิการบดี 
                  </p>
                </div>
                <br />
                

              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderSignBoxEN() {
    //Run: เพิ่ม listweight ของ topic หลัก 14/04/2021
    const listWeightsTotal = this.state.weight.map(
      (
        { SubSubToppicId, SubToppicId, ToppicId, WeightCriteria, IsMainTopic },
        Index
      ) => (
        <div
          key={Index}
          relateTopicID={ToppicId}
          relateSubToppicId={SubToppicId}
          relatedSubSubToppicID={SubSubToppicId}
          IsMainTopic={IsMainTopic}
        >
          <div>{WeightCriteria}</div>
        </div>
      )
    );

    const listItems = this.initArrays.TopicsArr.map(
      ({ ToppicId, TitleTH, TitleEN, DescriptionTH, DescriptionEN }, Order) => (
        <div
        // style={{
        //   padding: "10px 15px",
        //   borderBottom: "1px solid #DCDCDC",
        //   background: "#E8F7FF",
        // }}
        >
          {/* Run: เพิ่มการ ใส่ น้ำหนักคะแนนสำหรับ Topic 14/04/2021*/}

          {listWeightsTotal.filter((e) => {
            return (
              e.props.relateSubToppicId == 0 &&
              e.props.relateTopicID == ToppicId &&
              e.props.relatedSubSubToppicID == 0 &&
              e.props.IsMainTopic
            );
          })}
        </div>
      )
    );

    const totalclickpointTopic = this.AnsData.ansTotalClickTopic.map(
      ({ TopicId, CalPoint }, Index) => (
        <div key={Index} relateTopicID={TopicId}>
          {/* {CalPoint}
           */}
          {this.decimalPointChange(CalPoint)}
        </div>
      )
    );

    const listItems2 = this.initArrays.TopicsArr.map(
      ({ ToppicId, TitleTH, TitleEN, DescriptionTH, DescriptionEN }, Order) => (
        <div
        // style={{
        //   padding: "10px 15px",
        //   borderBottom: "1px solid #DCDCDC",
        //   background: "#E8F7FF",
        // }}
        >
          {/* Run: เพิ่มการ ใส่ น้ำหนักคะแนนสำหรับ Topic 14/04/2021*/}

          {totalclickpointTopic.filter((e) => {
            return e.props.relateTopicID == ToppicId;
          })}
        </div>
      )
    );

    console.log("listItems2 ", listItems2);

    return (
      <div>
        <Row>
          <Col span={16}>
            <table id="table-two">
              <tr>
                <th style={{ width: "70%", padding: 10 }}>Criteria and Indicators</th>
                <th style={{ padding: 10 }}> Weighted Score </th>
                <th style={{ padding: 10 }}> Score </th>
              </tr>
              <tr>
                <td>1. Workload</td>
                <td>{listItems[0]}</td>
                <td>{listItems2[0]}</td>
              </tr>
              <tr>
                <td>2. Other responsibilities</td>
                <td>{listItems[1]}</td>
                <td>{listItems2[1]}</td>
              </tr>
              <tr>
                <td>3. Quality of Work</td>
                <td>{listItems[2]}</td>
                <td>{listItems2[2]}</td>
              </tr>
              <tr>
                <td>4. Competency</td>
                <td>{listItems[3]}</td>
                <td>{listItems2[0]}</td>
              </tr>
              <tr>
                <td>
                  <b>Total Score (1 + 2 + 3 + 4) </b>
                </td>
                <td>
                  <b> 100.00 </b>
                </td>
                <td>
                  <b>{this.decimalPointChange(this.AnsData.TotalCalculate)}</b>
                </td>
              </tr>
            </table>
          </Col>

          <Col span={8}>
            <div style={{ border: "2px solid black", padding: 15 }}>
            <b style={{ fontSize: 12, marginBottom: 15 }}>
                  comments and/or suggestions of the assessor
                </b>

              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
            
                <p>
                  __________________________________________________________________________________________________________
                 <br/> __________________________________________________________________________________________________________
                <br/>__________________________________________________________________________________________________________
                </p>
                <br />
                <div style={{ textAlign: "center" }}>
                <p> Signature _________________________________<br/>
                  (______________________)</p>
                  <p> Position: _______________________________</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={8}>
            <div style={{ border: "2px solid black", padding: 15 }}>
              <b style={{ fontSize: 12, marginBottom: 15 }}>
                 comments and/or suggestions of the Dean/Director
              </b>

              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <br/>
           
                <p>
                  __________________________________________________________________________________________________________
                 <br/> __________________________________________________________________________________________________________
                <br/>__________________________________________________________________________________________________________
                </p>
           
                <div style={{ textAlign: "center" }}>
                  <p> Signature _________________________________<br/>
                  (______________________)</p>
                  <p> Position: _______________________________</p>
                </div>
              </div>
            </div>
          </Col>

          <Col span={8}>
            <div style={{ border: "2px solid black", padding: 15 }}>
              <b style={{ fontSize: 12, marginBottom: 15 }}>
                 comments and/or suggestions of the Vice President/Assistant to the President
              </b>

              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >

                <p>
                  __________________________________________________________________________________________________________
                 <br/> __________________________________________________________________________________________________________
                <br/>__________________________________________________________________________________________________________
                </p>

                <div style={{ textAlign: "center" }}>
                <p> Signature _________________________________<br/>
                  (______________________)</p>
                  <p> Position: _______________________________</p>
                </div>
              </div>
            </div>
          </Col>

          <Col span={8}>
            <div style={{ border: "2px solid black", padding: 15 }}>
              <b style={{ fontSize: 12, marginBottom: 15 }}>
                comments and/or suggestions of the Interim President
              </b>

              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <br/>



                <ul class="a">
                  <li>Approved</li>
                  <li> Not Approved ........................................................................................</li>
                </ul>


                <div style={{ textAlign: "center" }}>
                <br/>
                  <p> Signature _________________________________</p>
                  <p>
                     (Mr. Apicha Insuwan) <br />
                    Position: The Interim President
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
clicksavePdf(content,comref){
  console.log('content',content)
  console.log('comref',comref)
    html2canvas(comref).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("download.pdf");
    });
}
  render() {
    console.log("spiner", this.state.spinner);
    console.log('this.props.location.state.record',this.props.location.state.record)

    return (
      <div>
        <Spin tip="Loading..." spinning={this.state.spinner}>
          <Affix offsetTop={85}>
            {this.state.language == "TH" ? (
              <PageHeader
                className="site-page-header"
                onBack={() => window.history.back()}
                title={
                  "แบบฟอร์มการประเมินผู้ใต้สังกัด : " +
                  this.props.location.state.record.TitleTH +
                  " " +
                  this.props.location.state.record.FirstNameTH +
                  " " +
                  this.props.location.state.record.LastNameTH +
                  " (" +
                  this.props.location.state.record.EmpId +
                  ")"
                }
              />
            ) : (
              <PageHeader
                className="site-page-header"
                onBack={() => window.history.back()}
                title={
                  "Assessing Subordinate Form : " +
                  this.props.location.state.record.TitleEN +
                  " " +
                  this.props.location.state.record.FirstNameEN +
                  " " +
                  this.props.location.state.record.LastNameEN +
                  " (" +
                  this.props.location.state.record.EmpId +
                  ")"
                }
              />
            )}
          </Affix>

          <ReactToPrint
            trigger={() => {
              return (
                <div
                  style={{
                    textAlign: "center",
                    margin: "auto",
                    marginBlock: 15,
                  }}
                >
                  {this.state.language == "TH" ? (
                    <Button type="primary">พิมพ์รายงาน</Button>
                  ) : (
                    <Button type="primary">Print Report</Button>
                  )}
                </div>
              );
            }}
            content={() => this.componentRef}
          />

          <div
            ref={(el) => (this.componentRef = el)}
            style={{ marginLeft: 15, marginRight: 15 }}
          >
            {/* render header */}

            {this.state.language == "TH" ? (
              <div>
                <h3 style={{ textAlign: "center" }}>
                  {"แบบฟอร์มการประเมินผู้ใต้สังกัด : " +
                    this.props.location.state.record.TitleTH +
                    " " +
                    this.props.location.state.record.FirstNameTH +
                    " " +
                    this.props.location.state.record.LastNameTH +
                    " (" +
                    this.props.location.state.record.EmpId +
                    ")"}
                </h3>
                <h3 style={{ textAlign: "center" }}>
                  {"สังกัด " + this.props.location.state.record.SectorNameTH}
                </h3>
              </div>
            ) : (
              <div>
                <h3 style={{ textAlign: "center" }}>
                  {"Assessing Subordinate Form : " +
                    this.props.location.state.record.TitleEN +
                    " " +
                    this.props.location.state.record.FirstNameEN +
                    " " +
                    this.props.location.state.record.LastNameEN +
                    " (" +
                    this.props.location.state.record.EmpId +
                    ")"}
                </h3>
                <h3 style={{ textAlign: "center" }}>
                  {this.props.location.state.record.SectorNameEN}
                </h3>
              </div>
            )}

            {this.renderTable()}

            {/* sign box */}
            {this.state.language == 'TH'? this.renderSignBoxTH() : this.renderSignBoxEN()}
          </div>

          {/* {this.state.spinner == true? window.print() : null} */}
        </Spin>
      </div>
    );
  }
}
